module.exports = __webpack_public_path__ + "static/media/CloseUp.b2bbb0a8.jpeg";